import { styled } from '@spazious/dollhouse-theme';

import { Flex, FlexElement, FlexProps } from '../Flex/index.js';

export type TooltipArrowElement = FlexElement;
export interface TooltipArrowProps extends FlexProps {
  size?: React.CSSProperties['width'] | React.CSSProperties['height'];
}
export const TooltipArrow = styled(Flex).withConfig({
  displayName: 'TooltipArrow',
})<TooltipArrowProps>`
  --spz-tooltip-arrow-size: ${({ size = '25px' }) => size};
  width: 50px;
  height: 25px;
  position: absolute;
  top: 100%;
  left: 50%;
  transform: translateX(-50%);
  overflow: hidden;

  &::after {
    content: '';
    position: absolute;
    width: 20px;
    height: 20px;
    background-color: var(--spz-sys-color-surface-container);
    transform: translateX(-50%) translateY(-50%) rotate(45deg);
    top: 0;
    left: 50%;
    box-shadow: 1px 1px 10px 0px rgba(0, 0, 0, 0.2);
  }

  &[data-popper-placement^='top'] {
    bottom: calc(-1 * var(--spz-tooltip-arrow-size));
  }

  &[data-popper-placement^='bottom'] {
    top: -25px;
    &::after {
      top: 25px;
    }
  }

  &[data-popper-placement^='left'] {
    right: -25px;
    &::after {
      right: 25px;
    }
  }

  &[data-popper-placement^='right'] {
    left: -25px;
    width: 25px;
    height: 50px;
    &::after {
      top: 50%;
      left: 25px;
    }
  }

  &[data-hide='true'] {
    visibility: hidden !important;
  }
`;
